import React, {memo, useState, useRef, useCallback} from 'react';
import {TouchableOpacity} from 'react-native';
import {useTooltip} from '@redlink/components/molecules';

export const ToolTip = memo(({children, renderButton}) => {
    const [layout, setLayout] = useState({});
    const elementRef = useRef(null);
    const {showTooltip} = useTooltip();

    const onLayout = useCallback(() => {
        setTimeout(() => elementRef.current?.measure((fx, fy, width, height, px, py) => {
            setLayout({x: px, y: py, width, height});
        }), 500)
    }, []);

    return (
        <TouchableOpacity
            activeOpacity={0.7}
            ref={elementRef}
            {...{onLayout}}
            onPress={() => showTooltip(layout, (navigation) => React.cloneElement(React.Children.only(children), {navigation,}))}
        >
            {renderButton?.()}
        </TouchableOpacity>
    );
});
